import React, { useEffect, useState, useRef } from "react";
import { Chart } from "primereact/chart";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

export const AccWiseInventoryChart = (props) =>{

    const [data1,setData1] = useState(null)
    const [data2,setData2] = useState(null)
    const [label,setLabel] = useState(null)
    const [chartData,setChartData] = useState(null)

    const dt = useRef(null);

    useEffect(()=>{
        getData(props.inventoryPerData)
        setChartData(props.inventoryPerData)
    },[props.inventoryPerData])

    const getData = (data) =>{
        if(data){
            console.log(data);
            const loaded = data.map(x => x.loaded_packets)
            setData1(loaded)
            const used = data.map(x => x.used_packets)
            setData2(used)
            const label = data.map(x => x.siteName2)
            setLabel(label)
        }
    }

    const fieldTemplate = (rowData, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {rowData[props.field]}
            </>
        );
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    }
    

    const stackedData = {
        labels: label,
        datasets: [{
            type: 'bar',
            label: 'Loaded Packets',
            backgroundColor: '#06685d4a',
            data: data1,
            borderRadius: 5
        }, {
            type: 'bar',
            label: 'Used Packets',
            backgroundColor: '#00544D',
            data: data2,
            borderRadius: 5
        }]
    };
    
    const stackedOptions = {
        maintainAspectRatio: false,
        aspectRatio: .5,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    return (
        
        <div className="card">
            <div className="card-header">
                <span>Flavorwise Cup Consumption</span>
                <div className='p-col-sm-4'>
                    <Button icon="pi pi-download" title='Download Report' className="p-button-rounded p-button-primary p-mr-2 p-mb-2" onClick={exportCSV} />
                </div>
            </div>
            <Chart type="bar" data={stackedData} options={stackedOptions} />

            <DataTable style={{ display: 'none' }} ref={dt} value={chartData} dataKey="id" exportFilename="Accountwise Inventory Performance" className="datatable-responsive" emptyMessage="No data found.">
                <Column field="siteName2" header="Company Name" body={fieldTemplate}></Column>
                <Column field="total_packets" header="Total Packets" body={fieldTemplate}></Column>
                <Column field="loaded_packets" header="Loaded Packets" body={fieldTemplate}></Column>
                <Column field="used_packets" header="Used Packets" body={fieldTemplate}></Column>
                <Column field="used_cups" header="Total Cups" body={fieldTemplate}></Column>
            </DataTable>
        </div>

    )
}